import { css } from "styled-components";

/**
 * Due to increased css specificity in antdV5, certain styles are overriden
 **/
export const AntStatisticV5Styled = css`
.ant-statistic-content * {
    font-size: inherit !important;  
}


`;
